<template>
  <div class="ml-4 p-3">
    <RevIllustration alt="" :height="18" :src="logo.url" :width="18" />
  </div>
</template>

<script setup lang="ts">
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  logo: NonNullable<MobilePlanOffer['partner']['logo']>
}>()
</script>
